<template>
	<div class="comp">
		<el-dialog :title="'新建顾客档案'" :visible.sync="dialogState" width="1200px" @close="dialogClose" :close-on-click-modal="false">
			<el-form :model="form" :rules="rules" ref="form">
				<el-row>
					<el-col :span="6">
						<el-form-item label="顾客名称" :label-width="formLabelWidth" prop="userName">
							<el-input v-model="form.userName" placeholder="请输入顾客昵称" autocomplete="off" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="手机号" :label-width="formLabelWidth" prop="userPhone">
							<el-input v-model="form.userPhone" placeholder="请输入顾客手机号" autocomplete="off" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="紧急联系人" :label-width="formLabelWidth" >
							<el-input v-model="form.urgent_user" placeholder="请输入紧急联系人" autocomplete="off" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="紧急联系电话" :label-width="formLabelWidth" >
							<el-input v-model="form.urgent_user_mobile" placeholder="请输入紧急电话" autocomplete="off" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="宠物昵称" :label-width="formLabelWidth" prop="petName">
							<el-input v-model="form.petName" placeholder="请输入宠物昵称" autocomplete="off" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="宠物性别" :label-width="formLabelWidth" prop="sex">
							<el-select style="width:100%" v-model="form.sex" placeholder="请选择性别">
								<el-option v-for="item in [{label:'公',value:'公'},{label:'母',value:'母'}]" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="种类" :label-width="formLabelWidth" prop="class_name">
							<el-radio-group v-model="form.class_name" @change="form.type_name='';getPetTypeList(form.class_name)">
								<el-radio :label="'犬类'">犬</el-radio>
								<el-radio :label="'猫类'">猫</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="品种" :label-width="formLabelWidth" prop="type_name">
							<el-select class="select" filterable default-first-option v-model="form.type_name" @change="changeType" placeholder="请选择品种">
								<el-option v-for="item in typeList" :key="item._id" :label="item.name" :value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="是否绝育" :label-width="formLabelWidth" prop="sterilization">
							<el-select class="select" v-model="form.sterilization" placeholder="请选择">
								<el-option v-for="item in [{label:'是',value:1},{label:'否',value:0}]" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="宠物出生日期" :label-width="formLabelWidth" prop="petBirth">
							<el-date-picker style="width:160px;" v-model="datePickerValue" :picker-options="{disabledDate(time) {return new Date().getTime() < time.getTime()}}" @change="changeDatePicker" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="宠物年龄" :label-width="formLabelWidth">
							<el-input v-model="ageYear" @input="changeAge" style="width:110px;margin-right: 10px;">
								<template slot="append">年</template>
							</el-input>
							<el-input v-model="ageMonth" @input="changeAge" style="width:110px">
								<template slot="append">月</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:true,
				formLabelWidth: '130px',
				typeList: [],
				datePickerValue:'',
				ageMonth:'',
				ageYear:'',
				form:{
					userName:'',
					userPhone:'',
					urgent_user:'',
					urgent_user_mobile:'',
					petName:'',
					class_name:'犬类',
					type_name:'',
					sex:'',
					petBirth:'',
					petAge:[],
					sterilization:'',
				},
				rules: {
					userName: [{ required: true, message: '请输入顾客名称', trigger: 'change' }],
					userPhone: [{ required: true, message: '请输入顾客手机号', trigger: 'change' }],
					petName: [{ required: true, message: '请输入宠物名称', trigger: 'change' }],
					class_name: [{ required: true, message: '请选择宠物种类', trigger: 'change' }],
					type_name: [{ required: true, message: '请选择宠物品种', trigger: 'change' }],
					sex: [{ required: true, message: '请选择宠物性别', trigger: 'change' }],
					petBirth: [{ required: true, message: '请选择宠物生日', trigger: 'change' }],
					petAge: [{ required: true, message: '请输入宠物年龄', trigger: 'change' }],
					sterilization: [{ required: true, message: '请选择是否绝育', trigger: 'change' }],
				}
			}
		},
		props:{
			userInfo:{
				default:()=>{
					return {}
				}
			}
		},
		mounted() {
			this.getPetTypeList();
		},
		methods: {
			dialogClose(){
				this.$emit("submit")
			},
			cancel(){
				this.$emit("submit")
			},
			getPetTypeList(str){
				this.$util.getTypeList(str).then(list=>{
					this.typeList=list;
				})
			},
			submit(){
				this.$refs.form.validate((valid) => {
					if (valid) {
						if(this.form.petName.length>8){
							this.$message({
								message: '宠物昵称不能大于8个字符',
								type: 'error'
							});
							return ;
						}
						if(this.datePickerValue){
							this.form.petBirth = this.$public.FTime((''+new Date(this.datePickerValue).getTime()).substr(0,10),'YYYY-MM-DD')
							this.form.petAge = [this.ageYear||'0',this.ageMonth||'0']
						}
						let params = {
							"user_mobile": this.form.userPhone,
							"nick_name": this.form.userName,
							"avatar_pic": "",
							"user_email": "",
							"user_address": "",
							"sex": "",
							"birthday":"",
							"user_type": 0,
							"home_address": "",
							"urgent_user": this.form.urgent_user,
							"urgent_user_mobile": this.form.urgent_user_mobile,
							"remark": "",
							"pet_info": {
								"nick_name": this.form.petName,
								"chip_no": "",
								"class_name": this.form.class_name,
								"type_name": this.form.type_name,
								"sex": this.form.sex,
								"color": "",
								"remark": "",
								"hs_pet": false,
								"status": 0,
								"sterilization": this.form.sterilization,
								"immunization": 0,
								"dewormed": 0,
								"birth_day": this.form.petBirth,
								"home_day": "",
								"avatar_pic": "",
								"tool_num": "",
								"weight": 0,
								"weight_remark": ""
							}
						}
						this.$http.post('/api/Member/InsertAndPet', params).then(res => {
							if (res.code == 0) {
								this.$message({
									message: '顾客档案创建成功',
									type: 'success'
								});
								this.$emit("submit",res.data)
							}
						})
					}
				})
			},
			changeAge(){
				let month = parseInt(Number(this.ageYear||0)*12+Number(this.ageMonth||0));
				this.datePickerValue = this.$public.FBirthday(month);
				this.form.petBirth = this.$public.FTime((''+new Date(this.datePickerValue).getTime()).substr(0,10),'YYYY-MM-DD');
			},
			changeDatePicker(d){
				let a = this.$public.FAge(d);
				this.form.petBirth = this.$public.FTime(new Date(d).getTime().toString().substr(0,10),'YYYY-MM-DD');
				this.ageYear = a[0];
				this.ageMonth = a[1];
			},
			// 选择性别
			changeSex(a){
				this.form.sex = a[0];
				this.form.sterilization = a[1];
			},
			// 修改宠物品种
			changeType(str){
				this.form.type_name=str;
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		
	}
</style>
